<template>
	<div class="clearfix">
		<div class="top-bar">
			<div class="top-color">
				<img src="https://testing-oss.oss-cn-shanghai.aliyuncs.com/2019/06/19/46c041b.jpg?1560929792#w" alt="" />
				<span style="float: left;font-size:29px; font-weight:200; color: white;padding-left: 40px;line-height: 50px;">Welcome to Clarins</span>
			</div>
		</div>
		<div class="login">
			<!-- <img src="../assets/img/bg.jpg" alt="" class="pic-dev"/> -->
		</div>
		<div>
			<img class="activeImg" src="../assets/img/woman123.png" alt="" />
		</div>
		<div class="small-box">
			<el-form ref="form" :model="form" label-width="80px">
				<el-row type="flex" justify="center">
					<el-col :span="12">
						<el-form-item>
							<span class="span-img" @click="get()"></span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="12">
						<el-form-item label="账号">
							<el-input style="width: 300px;" v-model="form.name" class="input-pink">
								<img src="../assets/img/denglu.png" alt="" />
							</el-input>
							<span class="img-input"></span>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row type="flex" justify="center">
					<el-col :span="12">
						<el-form-item label="密码">
							<el-input @keyup.native.enter="onSubmit" style="width: 300px;" type="password" v-model="form.password" class="input-pink"></el-input>
							<span class="img-inputo"></span>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row type="flex" justify="center">
					<el-col :span="24">
						<el-form-item style="padding-top: 30px;margin-left: 75px;">
							<el-button type="danger" round @click="onSubmit">登陆网站</el-button>
							<span @click="password" style="margin-left:20px;color:#BE0F34;font-size: 14px;cursor: pointer;display: inline-block;">忘记密码</span>
						</el-form-item>

					</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="24">
						<el-form-item style="padding-top: 70px;padding-right: 10px;float: right;">
							<br>
							<span  style="margin-left:20px;color:#BE0F34;font-size: 14px;cursor: pointer;display: inline-block;"><a target="_blank" href="https://beian.miit.gov.cn/">沪ICP备19026787号</a></span>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		
		</div>
		
	</div>
	
</template>

<script>
import { login } from '../api/service'
import { getLocalStoreEver, setLocalStoreEver } from '../util/util'

export default {
	data() {
		return {
			username: '',
			form: {
				name: getLocalStoreEver('User-Name'),
				password: ''
			}
		}
	},
	methods: {
		password() {
			this.$router.push({ path: 'forgetPassword' })
		},
		onSubmit() {
			const params = {
				loginName: this.form.name,
				loginPwd: this.form.password
			}
			login(params)
				.then(response => {
					if (response.data.success === true) {
						this.$store.dispatch('setAccessId', response.data.data.id)
						this.$store.dispatch('setUserName', response.data.data.loginName)
						this.$store.dispatch('setUserPhone', response.data.data.phone)
						this.$store.dispatch(
							'setDeliveryAddress',
							response.data.data.deliveryAddress
						)
						setLocalStoreEver('User-Name', response.data.data.loginName)
						this.$message({ type: 'success', message: '登录成功!' })
						this.$router.push({
							path: '/list'
						})
					} else {
						this.$alert('账号或者密码错误', '提示', {
							confirmButtonText: '确定'
						})
					}
				})
				.catch(() => {
					this.$message({ type: 'warning', message: '登录失败!' })
				})
		}
	}
}
</script>

<style scoped>
.clearfix:after {
	content: '';
	display: block;
	clear: both;
}
a {
	text-decoration: none;
}

.el-form-item__content {
	font-size: 18px;
}
.el-form-item__label {
	font-size: 18px;
}
.sbbox {
	position: relative;
}
.pic-dev {
	width: 100%;
	height: 100%;
	margin-top: 8px;
}
.login {
	margin-top: 55px;
	height: calc(100vh - 55px);
	width: 100%;
	background: url('../assets/img/bg.jpg') 0 0 repeat-x;
}
.small-box {
	margin-left: 60%;
	position: absolute;
	top: 30%;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
	border-bottom: 1px solid #e5e5e5;
}
.top-color {
	height: 55px;
	background: #be0f34;
}
.top-color img {
	float: right;
	padding-right: 218px;
	width: 209px;
	margin-top: 16px;
}
.last-line-big-box {
	height: 50px;
	background-color: #e5e5e5;
}
.last-line-box {
	position: fixed;
	top: auto;
	bottom: -1px;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
	border-bottom: 1px solid #e5e5e5;
}
.last-line {
	height: 55px;
	background-color: #000000;
}
.last-font {
	margin-right: 65px;
	margin-top: 16px;
	float: right;
}
.last-font a {
	font-size: 14px;
	color: white;
}
.last-font img {
	float: right;
}
.last-line-follow {
	margin-right: 65px;
	margin-top: 16px;
	float: right;
}
.last-line-follow a {
	font-size: 14px;
	color: white;
}
.last-line-follow img {
	float: right;
	margin-left: 15px;
}
.last-line-details {
	float: left;
	margin-top: 16px;
	margin-left: 65px;
}
.last-line-details a {
	font-size: 14px;
	color: white;
}
.span-img {
	float: right;
	margin-right: -48px;
	width: 207px;
	height: 63px;
	/* background-image: url(../assets/img/logot.png); */
	background-repeat: no-repeat;
	background-size: 100%;
}
.img-input {
	position: absolute;
	/* top: 12px; */
	/* left: 6px; */
	top: 10px;
	left: -40px;
	width: 22px;
	height: 30px;
	background-image: url(../assets/img/yonghu.png);
	background-repeat: no-repeat;
	background-size: 100%;
}
.img-inputo {
	position: absolute;
	top: 6px;
	/* left: 2px; */
	left: -44px;
	width: 28px;
	height: 30px;
	background-image: url(../assets/img/suoo.png);
	background-repeat: no-repeat;
	background-size: 100%;
}
.activeImg {
	height: 90%;
	position: absolute;
	bottom: 0;
	left: 9%;
}
</style>
